(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["senova-offer-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('senova-buy-now')) {
    customElements.define('senova-buy-now', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.button = this.querySelector('button');
        this.form = this.closest('form');
        if (!this.button || !this.form) return;
        this.ready = true;
        this.events = new AbortController();
        const keepOfferSelected = (event) => {
          if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
          const control = event.target.closest('.kaching-bundles__bar-main');
          const bar = control?.closest('.kaching-bundles__bar');
          if (!bar || !this.form.contains(bar)) return;
          this.requestedOfferId = bar.dataset.dealBarId;
          if (bar.classList.contains('kaching-bundles__bar--selected')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
          if (!this.busy && !this.needsReview) {
            const feedback = this.form.querySelector('[data-feedback]');
            if (feedback) {
              feedback.removeAttribute('data-state');
              feedback.textContent = '';
            }
          }
        };
        this.form.addEventListener('click', keepOfferSelected, {capture: true, signal: this.events.signal});
        this.form.addEventListener('keydown', keepOfferSelected, {capture: true, signal: this.events.signal});
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          void this.buy();
        }, {signal: this.events.signal});
        this.form.addEventListener('submit', (event) => {
          if (this.busy || this.pending) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!this.busy) void this.buy(false);
          }
        }, {capture: true, signal: this.events.signal});
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          this.busy = false;
          this.restoreControls();
          if (this.needsReview) this.showError(this.dataset.cartReview, true);
        }, {signal: this.events.signal});
      }

      disconnectedCallback() {
        this.events?.abort();
        this.restoreControls();
        this.ready = false;
      }

      static metadata(item) {
        try {
          return JSON.parse(item.properties?.__kaching_bundles || '{}');
        } catch {
          return {};
        }
      }

      static identity(item, selection = false) {
        const meta = this.metadata(item);
        const properties = Object.entries(item.properties || {}).filter(([key]) => key !== '__kaching_bundles').map(([key, value]) => [key, String(value)]).sort(([a], [b]) => a.localeCompare(b));
        return JSON.stringify([String(item.variant_id || item.id), String(item.selling_plan || item.selling_plan_allocation?.selling_plan?.id || ''), String(meta.deal || ''), selection ? '' : String(meta.id || ''), String(meta.gift || ''), properties]);
      }

      static key(item) {
        return this.identity(item);
      }

      static group(items) {
        const grouped = new Map();
        for (const item of items) {
          const key = this.identity(item);
          const current = grouped.get(key);
          if (current) current.quantity += item.quantity;
          else grouped.set(key, {...item});
        }
        return [...grouped.values()];
      }

      static matches(line, item) {
        return this.identity(line) === this.identity(item);
      }

      static quantities(cart, item) {
        return cart.items.filter((line) => this.matches(line, item)).reduce((sum, line) => sum + line.quantity, 0);
      }

      static verify(before, after, items, quotedPrice, checkPrice = true) {
        let price = 0;
        for (const item of this.group(items)) {
          const lines = after.items.filter((line) => this.matches(line, item));
          const quantity = lines.reduce((sum, line) => sum + line.quantity, 0);
          if (quantity !== this.quantities(before, item) + item.quantity) return false;
          if (!checkPrice) continue;
          if (lines.some((line) => !Number.isFinite(line.final_line_price))) return false;
          const total = lines.reduce((sum, line) => sum + line.final_line_price, 0);
          if (this.metadata(item).gift && total !== 0) return false;
          price += total * item.quantity / quantity;
        }
        return !checkPrice || Math.round(price) <= quotedPrice + 1;
      }

      static sameSelection(a, b) {
        const signature = (bundle) => {
          const totals = new Map();
          for (const item of bundle.items) {
            const key = this.identity(item, true);
            totals.set(key, (totals.get(key) || 0) + item.quantity);
          }
          return JSON.stringify([...totals].sort(([a], [b]) => a.localeCompare(b)));
        };
        return a.quotedPrice === b.quotedPrice && signature(a) === signature(b);
      }

      async discardAttempt(cart, pending) {
        const Class = this.constructor;
        const ids = new Set(pending.bundle.items.map((item) => String(Class.metadata(item).id)));
        const lines = Class.offerLines(cart, pending.bundle.items).filter((line) => ids.has(String(Class.metadata(line).id)));
        if (!lines.length) return cart;
        if (lines.some((line) => !line.key)) throw new Error(this.dataset.cartReview);
        await this.request((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST', headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Kaching-Cart-Ignore': '1'},
          body: JSON.stringify({updates: Object.fromEntries(lines.map((line) => [line.key, 0]))})
        });
        const after = await this.readCart();
        const expected = {items: cart.items.filter((line) => !lines.includes(line))};
        if (!Class.preserved(expected, after)) throw new Error(this.dataset.cartReview);
        return after;
      }

      static offerLines(cart, items) {
        const deals = new Set(items.map((item) => String(this.metadata(item).deal)));
        return cart.items.filter((line) => deals.has(String(this.metadata(line).deal)));
      }

      static preserved(before, after) {
        const totals = (cart) => {
          const result = new Map();
          for (const line of cart.items) {
            const key = this.key(line);
            result.set(key, (result.get(key) || 0) + line.quantity);
          }
          return result;
        };
        const expected = totals(before);
        const actual = totals(after);
        return expected.size === actual.size && [...expected].every(([key, quantity]) => actual.get(key) === quantity);
      }

      async replacePrevious(before, added, bundle) {
        const Class = this.constructor;
        const old = Class.offerLines(before, bundle.items);
        const oldGroups = new Set(old.map((line) => String(Class.metadata(line).id)));
        const currentGroups = new Set(bundle.items.map((line) => String(Class.metadata(line).id)));
        const isOld = (line) => Class.offerLines({items: [line]}, bundle.items).length && oldGroups.has(String(Class.metadata(line).id));
        let finalCart = added;
        const removals = Class.offerLines(added, bundle.items).filter(isOld);
        if (removals.length) {
          if (removals.some((line) => !line.key || currentGroups.has(String(Class.metadata(line).id)))) throw new Error(this.dataset.cartReview);
          try {
            await this.request((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
              method: 'POST',
              headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Kaching-Cart-Ignore': '1'},
              body: JSON.stringify({updates: Object.fromEntries(removals.map((line) => [line.key, 0]))})
            });
          } catch (error) {}
          finalCart = await this.readCart();
        }
        const offers = Class.offerLines(finalCart, bundle.items);
        const baseline = {items: before.items.filter((line) => !Class.offerLines({items: [line]}, bundle.items).length)};
        const unrelated = {items: finalCart.items.filter((line) => !Class.offerLines({items: [line]}, bundle.items).length)};
        if (offers.some((line) => !currentGroups.has(String(Class.metadata(line).id)))
          || !Class.preserved(baseline, unrelated)
          || !Class.verify({items: []}, {items: offers}, bundle.items, bundle.quotedPrice)
          || offers.some((line) => !bundle.items.some((item) => Class.matches(line, item)))) {
          throw new Error(this.dataset.priceChanged);
        }
      }

      prepareBundle(rotate = true) {
        const widget = this.form.querySelector('kaching-bundles-block');
        const selected = widget?.querySelector('.kaching-bundles__bar--selected');
        if (!selected || ['items', 'pricing', 'validateItemSelection', 'rotateBundleNonce'].some((method) => typeof widget[method] !== 'function')) {
          throw new Error(this.dataset.bundleLoading);
        }
        const validation = widget.validateItemSelection();
        if (!validation?.valid) throw new Error(validation?.message || this.dataset.bundleLoading);
        const deal = JSON.parse(widget.getAttribute('deal-block') || '{}');
        const bars = deal.dealBars || [];
        const index = bars.findIndex((bar) => bar.id === selected.dataset.dealBarId);
        if (index < 0) throw new Error(this.dataset.bundleLoading);
        if (rotate) widget.rotateBundleNonce();
        const items = JSON.parse(JSON.stringify(widget.items()));
        if (!Array.isArray(items) || !items.length || items.some((item) => !/^\d+$/.test(String(item.id)) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !this.constructor.metadata(item).deal)) {
          throw new Error(this.dataset.bundleLoading);
        }
        const subscription = items.some((item) => item.selling_plan);
        const eligible = (gift) => gift.productGID && (!gift.applyOnlyForSubscriptions || subscription);
        const gifts = (bars[index].freeGifts || []).filter(eligible);
        if (deal.progressiveGiftsEnabled && deal.progressiveGifts) {
          gifts.push(...(deal.progressiveGifts.gifts || []).filter((gift) => gift.giftType === 'product' && eligible(gift) && (gift.unlockAtBarOnly ? Number(gift.unlockAtBar) === index + 1 : Number(gift.unlockAtBar) <= index + 1)));
        }
        if (gifts.some((gift) => items.filter((item) => String(this.constructor.metadata(item).gift) === String(gift.id)).reduce((sum, item) => sum + item.quantity, 0) < Number(gift.quantity || 1))) {
          throw new Error(this.dataset.bundleLoading);
        }
        const properties = {};
        for (const [name, value] of new FormData(this.form)) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (!match || match[1] === '__kaching_bundles') continue;
          if (typeof value !== 'string') {
            if (value.size) throw new Error(this.dataset.error);
            continue;
          }
          properties[match[1]] = value;
        }
        for (const item of items) {
          const meta = this.constructor.metadata(item);
          if (meta.main || meta.collectionBreaksProduct) item.properties = {...properties, ...item.properties};
        }
        const amount = widget.pricing()?.discountedPrice?.amount;
        if (!Number.isFinite(amount) || amount < 0) throw new Error(this.dataset.bundleLoading);
        return {widget, items, quotedPrice: Math.round(amount * 100)};
      }

      async waitForBundle() {
        const deadline = Date.now() + 10000;
        let recoveryControl;
        while (this.isConnected) {
          const widget = this.form.querySelector('kaching-bundles-block');
          if (widget && this.widgetState?.widget !== widget) {
            this.widgetState = {widget, inert: widget.inert};
            widget.inert = true;
          }
          const selected = widget?.querySelector('.kaching-bundles__bar--selected');
          if (!selected || (this.requestedOfferId && selected.dataset.dealBarId !== this.requestedOfferId)) {
            const bars = [...(widget?.querySelectorAll('.kaching-bundles__bar') || [])];
            const bar = this.requestedOfferId ? bars.find((item) => item.dataset.dealBarId === this.requestedOfferId) : bars[0];
            const control = bar?.querySelector('.kaching-bundles__bar-main');
            if (control && control !== recoveryControl) {
              recoveryControl = control;
              control.click();
            }
          }
          try {
            const bundle = this.prepareBundle(false);
            const current = widget.querySelector('.kaching-bundles__bar--selected');
            if (!this.requestedOfferId || current?.dataset.dealBarId === this.requestedOfferId) return bundle;
          } catch (error) {
            if (error.message !== this.dataset.bundleLoading) throw error;
          }
          if (Date.now() >= deadline) throw new Error(this.dataset.bundleLoading);
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
        throw new Error(this.dataset.error);
      }

      async request(url, options = {}) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), options.method === 'POST' ? 40000 : 15000);
        try {
          const response = await fetch(url, {...options, credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
          const data = await response.json();
          return {ok: response.ok, status: response.status, data};
        } finally {
          clearTimeout(timer);
        }
      }

      async readCart() {
        const response = await this.request((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {'Accept': 'application/json'}});
        if (!response.ok) throw new Error(this.dataset.cartReview);
        const cart = response.data;
        if (!Array.isArray(cart.items)) throw new Error(this.dataset.cartReview);
        return cart;
      }

      lockControls(widget) {
        this.controls = [...this.form.querySelectorAll('button[type="submit"], .svo-buy-now-button')].map((control) => ({control, disabled: control.disabled}));
        if (widget) {
          this.widgetState = {widget, inert: widget.inert};
          widget.inert = true;
        }
        this.form.dataset.loading = 'true';
        this.button.setAttribute('aria-busy', 'true');
        this.controls.forEach(({control}) => { control.disabled = true; });
      }

      restoreControls() {
        if (!this.form || !this.button) return;
        this.form.dataset.loading = 'false';
        this.button.removeAttribute('aria-busy');
        this.controls?.forEach(({control, disabled}) => { control.disabled = disabled; });
        if (this.widgetState) this.widgetState.widget.inert = this.widgetState.inert;
        this.widgetState = null;
      }

      showError(message, review = false) {
        const feedback = this.form.querySelector('[data-feedback]');
        if (!feedback) return;
        feedback.dataset.state = 'error';
        feedback.textContent = message;
        if (review) {
          const link = document.createElement('a');
          link.href = this.dataset.cartUrl;
          link.textContent = this.dataset.viewCart;
          link.style.cssText = 'display:block;margin-top:8px;text-decoration:underline;font-weight:600';
          feedback.appendChild(link);
        }
      }

      async buy(checkout = true) {
        if (this.busy || this.button.disabled || this.form.dataset.loading === 'true' || !this.form.reportValidity()) return;
        this.busy = true;
        let redirected = false;
        let submitted = false;
        try {
          this.lockControls(this.form.querySelector('kaching-bundles-block'));
          const feedback = this.form.querySelector('[data-feedback]');
          if (feedback) {
            feedback.removeAttribute('data-state');
            feedback.textContent = '';
          }
          await this.waitForBundle();
          let bundle = this.prepareBundle();
          let before = await this.readCart();
          let after;
          if (this.pending) {
            submitted = true;
            if (this.constructor.sameSelection(bundle, this.pending.bundle)) {
              bundle = this.pending.bundle;
              after = before;
              before = this.pending.before;
              const ids = new Set(bundle.items.map((item) => String(this.constructor.metadata(item).id)));
              const present = this.constructor.offerLines(after, bundle.items).some((line) => ids.has(String(this.constructor.metadata(line).id)));
              if (!present) {
                this.pending = null;
                throw new Error(this.dataset.error);
              }
            } else {
              before = await this.discardAttempt(before, this.pending);
              this.pending = null;
            }
          }
          if (!after) {
            const oldOffers = this.constructor.offerLines(before, bundle.items);
            const newGroups = new Set(bundle.items.map((item) => String(this.constructor.metadata(item).id)));
            if (bundle.items.some((item) => !this.constructor.metadata(item).id)
              || oldOffers.some((line) => !this.constructor.metadata(line).id || newGroups.has(String(this.constructor.metadata(line).id)))) {
              throw new Error(this.dataset.cartReview);
            }
            this.pending = {before, bundle};
            submitted = true;
            try {
              await this.request((window.Shopify?.routes?.root || '/') + 'cart/add.js?kaching_bundles=true', {
                method: 'POST',
                headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Kaching-Cart-Ignore': '1'},
                body: JSON.stringify({items: bundle.items})
              });
            } catch (error) {}
            after = await this.readCart();
          }
          if (!this.constructor.verify(before, after, bundle.items, bundle.quotedPrice, false)) {
            throw new Error(this.dataset.cartReview);
          }
          await this.replacePrevious(before, after, bundle);
          this.pending = null;
          this.needsReview = false;
          window.location.assign(checkout ? this.dataset.checkoutUrl : this.dataset.cartUrl);
          redirected = true;
        } catch (error) {
          this.needsReview = Boolean(this.pending);
          this.showError(submitted ? this.dataset.cartReview + ' ' + (error.message === this.dataset.priceChanged ? this.dataset.priceChanged : '') : error.message || this.dataset.error, submitted);
        } finally {
          if (!redirected) {
            this.busy = false;
            this.restoreControls();
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
